module.exports = __webpack_public_path__ + "assets/0fe13a95651c11ecab8bc768edeb6a3d.png";